export default [
  {
    id: 1,
    name: 'Contrato Lumora Technologies',
    value: 12000,
    currency: 'BRL',
    labels: [{ title: 'Enterprise', color: '#1ACDB8' }],
  },
  {
    id: 2,
    name: 'Projeto Designify Studio',
    value: 8500,
    currency: 'BRL',
    labels: [{ title: 'Proposta enviada', color: '#5D9CEC' }],
  },
  {
    id: 3,
    name: 'Consultoria CodeHub Brasil',
    value: 24500,
    currency: 'BRL',
    labels: [{ title: 'Negociação', color: '#F6BB42' }],
  },
  {
    id: 4,
    name: 'Renovação Nexa Marketing',
    value: 6300,
    currency: 'BRL',
    labels: [{ title: 'Renovação', color: '#AC92EC' }],
  },
  {
    id: 5,
    name: 'Expansão Vértice Logística',
    value: 41800,
    currency: 'BRL',
    labels: [{ title: 'Upsell', color: '#48CFAD' }],
  },
];
